/**
 * Created by anthony on 9/28/14.
 */
/**
 * Created by richard on 7/14/14.
 */
var userSchoolModel = angular.module('userSchoolModel', ['baseModel']);
userSchoolModel.factory('UserSchoolModelFactory', function(BaseModel){
    var UserSchoolModel = function(){
        var args = ['userSchool/'];
        BaseModel.apply(this, args);
        this.endpoint = args[0];
    }
    UserSchoolModel.prototype = new BaseModel();
    UserSchoolModel.prototype.parent = BaseModel.prototype;
    UserSchoolModel.prototype.resolveData = function(arg)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }
    return UserSchoolModel;
});


userSchoolModel.service('UserSchoolModelService', function(UserSchoolModelFactory){
    var userSchoolModel = new UserSchoolModelFactory();
    return userSchoolModel;
});


